import { convertKeysToCamelCase } from '@shared/utils';
import {
  WcgAdvancedFilter,
  WcgAdvancedFilterOptions,
  WcgMenuOption,
} from '@wcg/frontend-framework';

import { GridAdvancedFilterOptions } from '../types/base-grid.type';

export function normalizeGridAdvancedFilters(
  advancedFilters: WcgAdvancedFilter | undefined,
): WcgAdvancedFilter {
  if (!advancedFilters) {
    return {};
  }

  return Object.entries(advancedFilters).reduce((acc, [key, filter]) => {
    acc[key] = convertKeysToCamelCase(filter) as GridAdvancedFilterOptions;
    return acc;
  }, {} as WcgAdvancedFilter);
}

export function getGridFilterValueField(
  filter: GridAdvancedFilterOptions,
): string | undefined {
  return filter.filterValueField;
}

export function getLinkedFilterKeysToLoad(
  advancedFilters: WcgAdvancedFilter,
  linkedFilterKeys: string[],
  dataObj: Record<string, unknown>,
): string[] {
  const hasRowData = Object.keys(dataObj).length > 0;

  return linkedFilterKeys.filter((key) => {
    const link = advancedFilters[key]?.link;
    if (!link) {
      return false;
    }

    return !link.includes('${') || hasRowData;
  });
}

export function remapSelectedFilterOptions(
  selectedValues: WcgAdvancedFilterOptions['value'],
  options: WcgMenuOption[],
): WcgAdvancedFilterOptions['value'] {
  if (!Array.isArray(selectedValues) || options.length === 0) {
    return selectedValues;
  }

  return selectedValues.map((selected) => {
    if (typeof selected !== 'object' || selected === null) {
      const matchedOption = options.find(
        (option) => option.value === String(selected),
      );
      return matchedOption ?? selected;
    }

    const selectedOption = selected as WcgMenuOption;
    const matchedOption = options.find((option) => {
      const selectedValue = selectedOption.value ?? selectedOption.id;
      const selectedLabel = selectedOption.label;

      return (
        option.value === selectedValue ||
        option.value === selectedOption.id ||
        option.label === selectedLabel
      );
    });

    return matchedOption ?? selected;
  }) as WcgAdvancedFilterOptions['value'];
}
